export const stores = {
  paging: { total: 31, count: 10, totalPages: 4, currentPage: 0 },
  stores: [
    {
      storeId: 'a8bd1f53-6172-4f1f-b78b-50c7cf052151',
      title: 'Boston QA (Incentivio)',
      address: {
        streetAddress1: '770 Battaramulla - Pannipitiya Rd',
        streetAddress2: 'Battaramulla 10120',
        city: 'Battaramulla 10120',
        postalCode: '10120',
        region: 'colombo',
        country: 'Sri Lanka',
      },
      phoneNumber: '1541622212',
      shortDescription: 'boston',
      longDescription: 'boston',
      regionId: '00094b0b-7e3b-11ea-892f-0aa9f0965c57',
      storeCode: 'STR:1186678318',
      latitude: 6.892794,
      longitude: 79.928212,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/d5ec9c42cade6c696ef244cc33efedd3_7ca8f6aa514947df83d7d212356d3929.gif',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/d5ec9c42cade6c696ef244cc33efedd3_5eca5cf24da04d1485a3344d35c6b04b.gif',
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Boston QA (Incentivio)',
          shortDescription: 'boston',
          longDescription: 'boston',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/d5ec9c42cade6c696ef244cc33efedd3_7ca8f6aa514947df83d7d212356d3929.gif',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/d5ec9c42cade6c696ef244cc33efedd3_5eca5cf24da04d1485a3344d35c6b04b.gif',
        },
        {
          languageCode: 'FR',
          title: 'Boston QA French',
          shortDescription: 'Boston QA French Short Desc.',
          longDescription: 'Boston QA French Long Desc.',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/d5ec9c42cade6c696ef244cc33efedd3_7ca8f6aa514947df83d7d212356d3929.gif',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/d5ec9c42cade6c696ef244cc33efedd3_5eca5cf24da04d1485a3344d35c6b04b.gif',
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
      isTest: true,
    },
    {
      storeId: '30951341-6bdc-44e2-bf7d-2a4db709e4a8',
      title: '171 Latte macchiato Test',
      address: {
        city: 'boston',
        country: 'United States',
        postalCode: '00500',
        region: 'Massachusetts',
        streetAddress1: 'G4, Royal Arcade Food Court',
        streetAddress2: 'Kirimandala st',
      },
      phoneNumber: null,
      shortDescription: '171 latte macchiato 171 latte macchiato',
      longDescription:
        '171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:4350758034',
      latitude: 42.338001,
      longitude: -71.591217,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/333_157e0383f57a4ce18ef08d10c1428bb6.jpg',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/55555_81c8c8a46e924d4fa81d3208a53405d7.jpg',
      displayInfo: [
        {
          languageCode: 'EN',
          title: '171 latte macchiato',
          shortDescription: '171 latte macchiato 171 latte macchiato',
          longDescription:
            '171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato 171 latte macchiato',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/333_157e0383f57a4ce18ef08d10c1428bb6.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/55555_81c8c8a46e924d4fa81d3208a53405d7.jpg',
        },
        {
          languageCode: 'FR',
          title: '171 Casual Dining & Deliveries',
          shortDescription: '171و Casual Dining & Deliveries',
          longDescription:
            '171و Casual Dining & Deliveries \nInspired by great fresh ingredients, our bakeries were transformed to a multi cuisine restaurant in 2014. We continue to fulfill the needs and desires of our guests with a menu of ingredient-inspired food. When you visit our restaurant, you’ll see real kitchens in place of assembly lines. You’ll hear the chopping of over 40 types of fresh herbs, fruits and vegetables, and the sizzle of our real panini grill. You’ll see the stove’s open flame and feel the warmth from our ovens working all day long. They’re the traditions we established years ago that we still passionately follow today.',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/333_157e0383f57a4ce18ef08d10c1428bb6.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/55555_81c8c8a46e924d4fa81d3208a53405d7.jpg',
        },
      ],
      isCatering: false,
      isMenuBrowsing: false,
      isTest: false,
    },
    {
      storeId: '06f89534-d4f2-4efe-823b-b8fa74bbc6c5',
      title: "Breckwood Shoppes(QA USE Don't Edit)",
      address: {
        streetAddress1: '12 brookline',
        streetAddress2: 'MA',
        city: 'Boston',
        postalCode: '12345',
        region: 'U.S. Minor Outlying Islands',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'Breckwood Shoppes',
      longDescription: 'Breckwood Shoppes',
      regionId: 'ee5be367-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:6326346060',
      latitude: 49.0,
      longitude: 72.0,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Breckwood Shoppes(QA USE DontEdit)',
          shortDescription: 'Breckwood Shoppes',
          longDescription: 'Breckwood Shoppes',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: '040b41cb-cf0e-4f24-9f85-60527cd5122b',
      title: '(Only to test TOAST -Apple-Pay) AET Rush Store QA',
      address: {
        city: 'Abington',
        country: 'United States',
        postalCode: '2351',
        region: 'Washington',
        streetAddress1: '777 Brockton Avenue',
        streetAddress2: 'MA',
      },
      phoneNumber: '5417543010',
      shortDescription:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed est risus, elementum eu pellentesque in, euismod et urna. Quisque dignissim, dolor a egestas tincidunt, metus elit congue massa, vehicula sollicitudin leo lectus vel quam. Etiam in ex quam. Integer nec turpis tempor, imperdiet nisl sed, consequat ante. In vulputate eros sit amet vulputate aliquam. Sed placerat, ligula a viverra dignissim, ipsum diam viverra massa, at xf sefs sfss sdfsf sdfsdf sdfsdf sdfsdfsdfsdfsf sfs fsfsfsdf sdfs fsd',
      longDescription:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed est risus, elementum eu pellentesque in, euismod et urna. Quisque dignissim, dolor a egestas tincidunt, metus elit congue massa, vehicula sollicitudin leo lectus vel quam. Etiam in ex quam. Integer nec turpis tempor, imperdiet nisl sed, consequat ante. In vulputate eros sit amet vulputate aliquam. Sed placerat, ligula a viverra dignissim, ipsum diam viverra massa, at xf sefs sfss sdfsf sdfsdf sdfsdf sdfsdfsdfsdfsf sfs fsfsfsdf sdfs fsdLorem ipsum dolor sit amet, consectetur adipiscing elit. Sed est risus, elementum eu pellentesque in, euismod et urna. Quisque dignissim, dolor a egestas tincidunt, metus elit congue massa, vehicula sollicitudin leo lectus vel quam. Etiam in ex quam. Integer nec turpis tempor, imperdiet nisl sed, consequat ante. In vulputate eros sit amet vulputate aliquam. Sed placerat, ligula a viverra dignissim, ipsum diam viverra massa, at xf sefs sfss sdfsf sdfsdf sdfsdf sdfsdfsdfsdfsf sfs fsfsfsdf sdfs fsd',
      regionId: 'ee5a65cc-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:2793018859',
      latitude: 23,
      longitude: 14,
      storeType: '11c0d09a-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: '(Only to test TOAST -Apple-Pay) AET Rush Store QA',
          shortDescription:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed est risus, elementum eu pellentesque in, euismod et urna. Quisque dignissim, dolor a egestas tincidunt, metus elit congue massa, vehicula sollicitudin leo lectus vel quam. Etiam in ex quam. Integer nec turpis tempor, imperdiet nisl sed, consequat ante. In vulputate eros sit amet vulputate aliquam. Sed placerat, ligula a viverra dignissim, ipsum diam viverra massa, at xf sefs sfss sdfsf sdfsdf sdfsdf sdfsdfsdfsdfsf sfs fsfsfsdf sdfs fsd',
          longDescription:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed est risus, elementum eu pellentesque in, euismod et urna. Quisque dignissim, dolor a egestas tincidunt, metus elit congue massa, vehicula sollicitudin leo lectus vel quam. Etiam in ex quam. Integer nec turpis tempor, imperdiet nisl sed, consequat ante. In vulputate eros sit amet vulputate aliquam. Sed placerat, ligula a viverra dignissim, ipsum diam viverra massa, at xf sefs sfss sdfsf sdfsdf sdfsdf sdfsdfsdfsdfsf sfs fsfsfsdf sdfs fsdLorem ipsum dolor sit amet, consectetur adipiscing elit. Sed est risus, elementum eu pellentesque in, euismod et urna. Quisque dignissim, dolor a egestas tincidunt, metus elit congue massa, vehicula sollicitudin leo lectus vel quam. Etiam in ex quam. Integer nec turpis tempor, imperdiet nisl sed, consequat ante. In vulputate eros sit amet vulputate aliquam. Sed placerat, ligula a viverra dignissim, ipsum diam viverra massa, at xf sefs sfss sdfsf sdfsdf sdfsdf sdfsdfsdfsdfsf sfs fsfsfsdf sdfs fsd',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isCatering: false,
      isMenuBrowsing: false,
      isTest: false,
    },
    {
      storeId: 'e1d0bb4b-3b66-4c4a-a83b-e9c28cee5ed4',
      title: 'AAA Gagana Test Store - Matara - Update',
      address: {
        city: 'mdddd',
        country: 'Sri Lanka',
        postalCode: '123',
        region: 'colombo',
        streetAddress1: '23',
        streetAddress2: '2222',
      },
      phoneNumber: '4546544444',
      shortDescription: 'AAA Gagana Test Store - Matara - Short Description',
      longDescription: 'AAA Gagana Test Store - Matara - Long Description',
      regionId: '00094b0b-7e3b-11ea-892f-0aa9f0965c57',
      storeCode: 'STR:1577174100',
      latitude: 42.33856,
      longitude: -72.58857,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/download%202_d4fb47596d6e491cb7c2e7e438fb998d.jpg',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/download%202_758074c8b040498b99f65bab0e32e94c.jpg',
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'AAA Gagana Test Store - Matara',
          shortDescription:
            'AAA Gagana Test Store - Matara - Short Description',
          longDescription: 'AAA Gagana Test Store - Matara - Long Description',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/download%202_d4fb47596d6e491cb7c2e7e438fb998d.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/download%202_758074c8b040498b99f65bab0e32e94c.jpg',
        },
      ],
      isCatering: false,
      isMenuBrowsing: false,
      isTest: false,
    },
    {
      storeId: '2ae986f9-ac5c-42a8-8c71-e36dbe591250',
      title: 'Brink Test Store',
      address: {
        streetAddress1: '25 Drydock Avenue',
        streetAddress2: 'Innovation and Design Building',
        city: 'Boston',
        postalCode: '02210',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'Brink Test Store',
      longDescription: 'Brink Test Store',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:3811468360',
      latitude: 42.5076967,
      longitude: -71.3233,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/download_480110ff3bc347af901d3a28ae50f948.jpg',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/download_34375064aabe49c7b1c6de9590d569c2.jpg',
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Brink Test Store',
          shortDescription: 'Brink Test Store',
          longDescription: 'Brink Test Store',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/download_480110ff3bc347af901d3a28ae50f948.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/download_34375064aabe49c7b1c6de9590d569c2.jpg',
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: '9a7e4879-7562-4a86-9478-adb467842ae3',
      title: "Catalog Testing store (Don't Edit)",
      address: {
        streetAddress1: '12 brookline avenue',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12345',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: "Catalog Testing store (Don't Edit)",
      longDescription: "Catalog Testing store (Don't Edit)",
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:9513849379',
      latitude: 67.778,
      longitude: 81.106706,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/RevelPizza_4b6800d8e95b4caa8a4cc13a4160c087.jpg',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/RevelPizza_4457fa0d543d4c6ba8687adfd86c56a5.jpg',
      displayInfo: [
        {
          languageCode: 'EN',
          title: "Catalog Testing store (Don't Edit)",
          shortDescription: "Catalog Testing store (Don't Edit)",
          longDescription: "Catalog Testing store (Don't Edit)",
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/RevelPizza_4b6800d8e95b4caa8a4cc13a4160c087.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/RevelPizza_4457fa0d543d4c6ba8687adfd86c56a5.jpg',
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: '3d922e86-2f3f-41b6-a1ce-19ffe94895ad',
      title: 'Decatur',
      address: {
        streetAddress1: '25 Drydock Avenue',
        streetAddress2: 'Innovation and Design Building',
        city: 'Boston',
        postalCode: '02210',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'Decatur ( QA USE  Lightspeed)',
      longDescription: 'Decatur ( QA USE  Lightspeed)',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:7232830406',
      latitude: 42.5076967,
      longitude: -71.24217759,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Decatur ( QA USE Lightspeed)',
          shortDescription: 'Decatur ( QA USE  Lightspeed)',
          longDescription: 'Decatur ( QA USE  Lightspeed)',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: '8d86a1ca-dfa9-4c9c-9f4b-6caa81509875',
      title: 'DEV TEAM - QU',
      address: {
        streetAddress1: 'Street Address 1',
        streetAddress2: 'Street Address 2',
        city: 'City',
        postalCode: '33101',
        region: 'Florida',
        country: 'United States',
      },
      phoneNumber: '12333244343',
      shortDescription: 'DEV TEAM - QU',
      longDescription: 'DEV TEAM - QU',
      regionId: 'ee55652b-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:8582747913',
      latitude: null,
      longitude: null,
      storeType: '11c0d09a-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'DEV TEAM - QU ****',
          shortDescription: 'DEV TEAM - QU',
          longDescription: 'DEV TEAM - QU',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: '458d1f38-daeb-4845-8531-7d6dc2cb2a8a',
      title: 'Do Not use (From the Herath Replica)',
      address: {
        streetAddress1: 'No 223 boston road',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12122',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'Do Not use (From the Herath Replica)',
      longDescription: 'Do Not use (From the Herath Replica)',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:9009742967',
      latitude: 79.009,
      longitude: -77.223,
      storeType: '11c0d09a-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/downloaddddd_1c6e134fd91040399d8d85364f383d2c.png',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/downloaddddd_968c49863a9741928b95aff75a04ef2a.png',
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Do Not use (From the Herath Replica)',
          shortDescription: 'Do Not use (From the Herath Replica)',
          longDescription: 'Do Not use (From the Herath Replica)',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/downloaddddd_1c6e134fd91040399d8d85364f383d2c.png',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/downloaddddd_968c49863a9741928b95aff75a04ef2a.png',
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: '37a5dcaa-f644-4828-b173-fd6d4aa00199',
      title: 'Do Not use (Its boba replica)',
      address: {
        streetAddress1: '12 brookline avanue',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12345',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'Do Not use (Its boba replica)',
      longDescription: 'Do Not use (Its boba replica)',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:9988152057',
      latitude: 79.009,
      longitude: -77.223,
      storeType: '11c0d09a-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/downloaddddd_7f57d02fb6a3488b8bf4b248f0014984.png',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/downloaddddd_dc4a844242474bf1b63cc01af46b3b5e.png',
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Do Not use (Its boba replica)',
          shortDescription: 'Do Not use (Its boba replica)',
          longDescription: 'Do Not use (Its boba replica)',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/downloaddddd_7f57d02fb6a3488b8bf4b248f0014984.png',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/downloaddddd_dc4a844242474bf1b63cc01af46b3b5e.png',
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: '76cfba32-e232-49bf-acde-4aec97aef1f9',
      title: 'Enfield (QA US  DONT EDIT)',
      address: {
        streetAddress1: '12  brookline avenue',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12345',
        region: 'U.S. Minor Outlying Islands',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'Enfield (QA US DONT EDIT)',
      longDescription: 'Enfield (QA US DONT EDIT)',
      regionId: 'ee5be367-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:6827754255',
      latitude: 41.0,
      longitude: 72.0,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Enfield (QA US DONT EDIT)',
          shortDescription: 'Enfield (QA US DONT EDIT)',
          longDescription: 'Enfield (QA US DONT EDIT)',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: true,
      isCatering: false,
    },
    {
      storeId: '3831ddf4-fa61-4eef-971c-f42b9f425c04',
      title: "Fenway - QA  (Don't Use)",
      address: {
        streetAddress1: 'san juan',
        streetAddress2: null,
        city: 'san juan',
        postalCode: '5455',
        region: 'Puerto Rico',
        country: 'United States',
      },
      phoneNumber: '5515653333',
      shortDescription: "Fenway - QA  (Don't Use)",
      longDescription: "Fenway - QA  (Don't Use)",
      regionId: 'ee5ba3eb-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:3346981442',
      latitude: 18.46556,
      longitude: -66.105738,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/imagesss_c6c958e38d1a40f599fccc89e62d4083.jpg',
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: "Fenway - QA  (Don't Use)",
          shortDescription: "Fenway - QA  (Don't Use)",
          longDescription: "Fenway - QA  (Don't Use)",
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/imagesss_c6c958e38d1a40f599fccc89e62d4083.jpg',
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: '5dad0de2-0a3b-41ee-aba6-6d928f0f39b0',
      title: "Fenway Kiosk New Dev (Don't Edit)",
      address: {
        streetAddress1: '12 brookline avanue',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12345',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription:
        "KIOSK's self-ordering entry kiosk systems provide convenient & cost-effective solutions for you. Perfect for restaurants, retail, & fast food.",
      longDescription: 'Do not Edit this location',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:5142291674',
      latitude: 42.3608739,
      longitude: -71.104878,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/cEdDG_a63440fb95c043f9a3438c59bb01e569.png',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/cEdDG_96834253f8d145a8b8390a936c838dde.png',
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Fenway Kiosk New Dev',
          shortDescription:
            "KIOSK's self-ordering entry kiosk systems provide convenient & cost-effective solutions for you. Perfect for restaurants, retail, & fast food.",
          longDescription: 'Do not Edit this location',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/cEdDG_a63440fb95c043f9a3438c59bb01e569.png',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/cEdDG_96834253f8d145a8b8390a936c838dde.png',
        },
      ],
      isMenuBrowsing: false,
      isCatering: true,
    },
    {
      storeId: 'f3f970b8-e560-4853-b6ef-0ea4bc3a42e8',
      title: 'Fiddleheads at Bayshore',
      address: {
        streetAddress1: '19 Crosby Drive,',
        streetAddress2: null,
        city: 'Bedford, MA',
        postalCode: '01730',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription:
        'Fiddleheads is committed to providing our customers with a unique and exceptional experience as a family, bicycle and dog friendly coffee shop.',
      longDescription:
        'Fiddleheads is committed to providing our customers with a unique and exceptional experience as a family, bicycle and dog friendly coffee shop.',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:4199894650',
      latitude: 52.1255,
      longitude: 79.125125,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Fiddleheads at Bayshore',
          shortDescription:
            'Fiddleheads is committed to providing our customers with a unique and exceptional experience as a family, bicycle and dog friendly coffee shop.',
          longDescription:
            'Fiddleheads is committed to providing our customers with a unique and exceptional experience as a family, bicycle and dog friendly coffee shop.',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: 'a8c7020b-27ff-4373-9896-abc4f41d3f59',
      title: 'Henderson',
      address: {
        streetAddress1: '12 brookline avenue',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12345',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'United States',
      longDescription: '12 Brookline Avenue , Boston , US',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:9434435023',
      latitude: 52.1255,
      longitude: 79.125125,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/MZ_Web_blackbarncafe_001_c81fdce158e146519884cd8cd1599c0d.jpg',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/MZ_Web_blackbarncafe_001_63d0cc727f7447fa84cc2e51902c3d81.jpg',
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Henderson - (QA USE ONLY | Revel )',
          shortDescription: 'United States',
          longDescription: '12 Brookline Avenue , Boston , US',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/MZ_Web_blackbarncafe_001_c81fdce158e146519884cd8cd1599c0d.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/MZ_Web_blackbarncafe_001_63d0cc727f7447fa84cc2e51902c3d81.jpg',
        },
      ],
      isMenuBrowsing: false,
      isCatering: true,
    },
    {
      storeId: '959650e6-c616-45f1-8e80-6b5e5b507e8e',
      title: 'IAC - TOAST',
      address: {
        streetAddress1: 'No 223 boston road',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12122',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'IAC - TOAST',
      longDescription: 'IAC - TOAST',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:6470588611',
      latitude: 79.009,
      longitude: -77.223,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'IAC - TOAST',
          shortDescription: 'IAC - TOAST',
          longDescription: 'IAC - TOAST',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: '63b9f30f-62fb-494c-8995-3cc939422f8f',
      title: 'kupfertandkim - Yorkville',
      address: {
        streetAddress1: '12 brookline avanue',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '02116',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'kupfertandkim - Yorkville',
      longDescription: 'kupfertandkim - Yorkville',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:3312942008',
      latitude: 42.360081,
      longitude: -71.058884,
      storeType: '11c0d09a-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'kupfertandkim - Yorkville',
          shortDescription: 'kupfertandkim - Yorkville',
          longDescription: 'kupfertandkim - Yorkville',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: '92988170-ccb2-4069-aae9-1e91fd65fd41',
      title: 'Lightspeed - Without Tax Classes',
      address: {
        streetAddress1: '92 Brookeline Street',
        streetAddress2: 'ssss',
        city: 'Boston',
        postalCode: '10300',
        region: 'New York',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'Lightspeed  Without Tax Classes',
      longDescription: 'Lightspeed  Without Tax Classes',
      regionId: 'ee5890b6-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:8911618134',
      latitude: 42.3601,
      longitude: 71.0589,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Lightspeed  Without Tax Classes11',
          shortDescription: 'Lightspeed  Without Tax Classes',
          longDescription: 'Lightspeed  Without Tax Classes',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: '91e91878-6dfb-4adc-b5dd-dd1f692c6a9c',
      title: 'Lightspeed Tax',
      address: {
        streetAddress1: 'No 223 boston road',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12122',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'Lightspeed Tax',
      longDescription: 'Lightspeed Tax',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:9809993228',
      latitude: 79.009,
      longitude: -77.223,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Lightspeed Tax',
          shortDescription: 'Lightspeed Tax',
          longDescription: 'Lightspeed Tax',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: 'fb6c1227-78b1-4d62-a670-c146ef060983',
      title: 'Milos QA Sync Test (NCC)',
      address: {
        streetAddress1: 'No 223 boston road',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12122',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'Milos Sync Test (NCC)',
      longDescription: 'Milos Sync Test (NCC)',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:2053146327',
      latitude: 79.009,
      longitude: -77.223,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Milos QA Sync Test (NCC)',
          shortDescription: 'Milos Sync Test (NCC)',
          longDescription: 'Milos Sync Test (NCC)',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: 'd181b335-12b1-4975-b6e5-6e9f45d7bfc5',
      title: 'Milos Spreedly',
      address: {
        streetAddress1: '19 Crosby Drive,',
        streetAddress2: 'Suite 160',
        city: 'Bedford, MA',
        postalCode: '01730',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: '15084391097',
      shortDescription: 'Milos Spreedly',
      longDescription: 'Milos Spreedly',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:2555297711',
      latitude: 52.0,
      longitude: 55.0,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Milos Spreedly',
          shortDescription: 'Milos Spreedly',
          longDescription: 'Milos Spreedly',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: 'a335ec88-18f1-417f-a67d-de181e1109e2',
      title: 'Milos Test (Timeout)',
      address: {
        streetAddress1: 'No 223 boston road',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12122',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'Milos Test (Timeout)',
      longDescription: 'Milos Test (Timeout)',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:9136286529',
      latitude: 79.009,
      longitude: -77.223,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Milos Test (Timeout)',
          shortDescription: 'Milos Test (Timeout)',
          longDescription: 'Milos Test (Timeout)',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: 'b865bd5f-1a1f-4c92-8b12-9a5569c41e01',
      title: 'Qu Store New',
      address: {
        streetAddress1: '460 W 42nd St',
        streetAddress2: null,
        city: 'New York',
        postalCode: '10036',
        region: 'New York',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'Qu Store New',
      longDescription: 'Qu Store New',
      regionId: 'ee5890b6-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:4422642560',
      latitude: 40.7590307,
      longitude: -73.9945665,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Qu Store New',
          shortDescription: 'Qu Store New',
          longDescription: 'Qu Store New',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: '040b41cb-cf0e-4f24-9f85-60527cd5123b',
      title: 'RUSH QA Store for Cypress',
      address: {
        streetAddress1: '777 Brockton Avenue',
        streetAddress2: 'MA',
        city: 'Abington',
        postalCode: '2351',
        region: 'Washington',
        country: 'United States',
      },
      phoneNumber: '5417543010',
      shortDescription:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed est risus, elementum eu pellentesque in, euismod et urna. Quisque dignissim, dolor a egestas tincidunt, metus elit congue massa, vehicula sollicitudin leo lectus vel quam. Etiam in ex quam. Integer nec turpis tempor, imperdiet nisl sed, consequat ante. In vulputate eros sit amet vulputate aliquam. Sed placerat, ligula a viverra dignissim, ipsum diam viverra massa, at xf sefs sfss sdfsf sdfsdf sdfsdf sdfsdfsdfsdfsf sfs fsfsfsdf sdfs fsd',
      longDescription:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed est risus, elementum eu pellentesque in, euismod et urna. Quisque dignissim, dolor a egestas tincidunt, metus elit congue massa, vehicula sollicitudin leo lectus vel quam. Etiam in ex quam. Integer nec turpis tempor, imperdiet nisl sed, consequat ante. In vulputate eros sit amet vulputate aliquam. Sed placerat, ligula a viverra dignissim, ipsum diam viverra massa, at xf sefs sfss sdfsf sdfsdf sdfsdf sdfsdfsdfsdfsf sfs fsfsfsdf sdfs fsdLorem ipsum dolor sit amet, consectetur adipiscing elit. Sed est risus, elementum eu pellentesque in, euismod et urna. Quisque dignissim, dolor a egestas tincidunt, metus elit congue massa, vehicula sollicitudin leo lectus vel quam. Etiam in ex quam. Integer nec turpis tempor, imperdiet nisl sed, consequat ante. In vulputate eros sit amet vulputate aliquam. Sed placerat, ligula a viverra dignissim, ipsum diam viverra massa, at xf sefs sfss sdfsf sdfsdf sdfsdf sdfsdfsdfsdfsf sfs fsfsfsdf sdfs fsd',
      regionId: 'ee5a65cc-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:2793018859',
      latitude: 23.0,
      longitude: 14.0,
      storeType: '11c0d09a-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'AET Rush Store QA',
          shortDescription:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed est risus, elementum eu pellentesque in, euismod et urna. Quisque dignissim, dolor a egestas tincidunt, metus elit congue massa, vehicula sollicitudin leo lectus vel quam. Etiam in ex quam. Integer nec turpis tempor, imperdiet nisl sed, consequat ante. In vulputate eros sit amet vulputate aliquam. Sed placerat, ligula a viverra dignissim, ipsum diam viverra massa, at xf sefs sfss sdfsf sdfsdf sdfsdf sdfsdfsdfsdfsf sfs fsfsfsdf sdfs fsd',
          longDescription:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed est risus, elementum eu pellentesque in, euismod et urna. Quisque dignissim, dolor a egestas tincidunt, metus elit congue massa, vehicula sollicitudin leo lectus vel quam. Etiam in ex quam. Integer nec turpis tempor, imperdiet nisl sed, consequat ante. In vulputate eros sit amet vulputate aliquam. Sed placerat, ligula a viverra dignissim, ipsum diam viverra massa, at xf sefs sfss sdfsf sdfsdf sdfsdf sdfsdfsdfsdfsf sfs fsfsfsdf sdfs fsdLorem ipsum dolor sit amet, consectetur adipiscing elit. Sed est risus, elementum eu pellentesque in, euismod et urna. Quisque dignissim, dolor a egestas tincidunt, metus elit congue massa, vehicula sollicitudin leo lectus vel quam. Etiam in ex quam. Integer nec turpis tempor, imperdiet nisl sed, consequat ante. In vulputate eros sit amet vulputate aliquam. Sed placerat, ligula a viverra dignissim, ipsum diam viverra massa, at xf sefs sfss sdfsf sdfsdf sdfsdf sdfsdfsdfsdfsf sfs fsfsfsdf sdfs fsd',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: '06f3898b-3148-4ea4-a644-a129a35270d9',
      title: 'Seattle - QU (QA Use)',
      address: {
        streetAddress1: '12 brookline avanue',
        streetAddress2: '12 brookline avanue',
        city: 'Boston',
        postalCode: '0600',
        region: 'Colorado',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'Seattle - QU (QA Use)',
      longDescription: 'Seattle - QU (QA Use)',
      regionId: 'ee54da8c-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:6600992647',
      latitude: 47.6154746,
      longitude: -122.3146017,
      storeType: '11c0d09a-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/sbs-filipinochickensoup_26a05bbd05ab45bc9dd770947cf506c3.jpg',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/pexels-navada-ra-1703272-e1597872285411_e2b35946b73146158e4698d6d558db8b.jpg',
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Seattle - QU (QA Use)',
          shortDescription: 'Seattle - QU (QA Use)',
          longDescription: 'Seattle - QU (QA Use)',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/sbs-filipinochickensoup_26a05bbd05ab45bc9dd770947cf506c3.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/pexels-navada-ra-1703272-e1597872285411_e2b35946b73146158e4698d6d558db8b.jpg',
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: '8358c24e-d5fc-443c-97d0-e0a21466a38e',
      title: 'Silverware - QA',
      address: {
        streetAddress1: '12 brookline avenue',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12345',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'Silverware - QA',
      longDescription: 'Silverware - QA',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:9921497365',
      latitude: 67.778,
      longitude: -58.992,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/RevelIcecream_c2efe694b4bf487f9a5d1ce6eafc9a8b.jpg',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/RevelIcecream_f8fcea9a66174f2c871e868a68e0f03c.jpg',
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Silverware - QA',
          shortDescription: 'Silverware - QA',
          longDescription: 'Silverware - QA',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/RevelIcecream_c2efe694b4bf487f9a5d1ce6eafc9a8b.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/RevelIcecream_f8fcea9a66174f2c871e868a68e0f03c.jpg',
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: '90269ca5-b39c-472b-8279-07bb5a4bc393',
      title: 'Test Store',
      address: {
        streetAddress1: 'No 223 boston road',
        streetAddress2: null,
        city: 'boston',
        postalCode: '0600',
        region: 'California',
        country: 'United States',
      },
      phoneNumber: '+64224540649',
      shortDescription: 'Test Store',
      longDescription: 'Test Store',
      regionId: 'ee54b786-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:2246997750',
      latitude: 79.009,
      longitude: null,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/pexels-navada-ra-1703272-e1597872285411_a7056a4800444db7887b1fe56c9ccde5.jpg',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/sbs-filipinochickensoup_513ab0dc42b14383aee0e412c0a3fd6a.jpg',
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Test Store',
          shortDescription: 'Test Store',
          longDescription: 'Test Store',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/pexels-navada-ra-1703272-e1597872285411_a7056a4800444db7887b1fe56c9ccde5.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/sbs-filipinochickensoup_513ab0dc42b14383aee0e412c0a3fd6a.jpg',
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: 'da2d3b2f-a29b-4e9d-a5d0-5d5c2725d70d',
      title: 'Test store 2',
      address: {
        streetAddress1: '12 brookline avanue',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12100',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: '+62224660649',
      shortDescription: 'Test store 2',
      longDescription: 'Test store 2',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:5038222082',
      latitude: 79.009,
      longitude: -77.223,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Test store 2',
          shortDescription: 'Test store 2',
          longDescription: 'Test store 2',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: '43a86007-a664-495a-bdac-fa90683283fc',
      title: 'Test Store22',
      address: {
        streetAddress1: 'No 223 boston road',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12122',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'Test Store',
      longDescription: 'Test Store',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:1595415015',
      latitude: 79.009,
      longitude: -77.223,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Test Store',
          shortDescription: 'Test Store',
          longDescription: 'Test Store',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: 'e410319a-d820-4da2-b08e-5e3242188a28',
      title: 'Toronto OTTER (QA Use)',
      address: {
        streetAddress1: '12 brookline avanue',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12345',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'Toronto OTTER (QA Use)',
      longDescription: 'Toronto OTTER (QA Use)',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:4317381537',
      latitude: 79.009,
      longitude: -77.223,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/MZ_Web_blackbarncafe_001_447f4b8e17584a8aaf9ee0cb5b5832ae.jpg',
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Toronto OTTER (QA Use)',
          shortDescription: 'Toronto OTTER (QA Use)',
          longDescription: 'Toronto OTTER (QA Use)',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/MZ_Web_blackbarncafe_001_447f4b8e17584a8aaf9ee0cb5b5832ae.jpg',
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: '952e1839-75f2-4d4b-9949-3760579583b8',
      title: 'Tower Sq (DON"T EDIT)',
      address: {
        streetAddress1: '12 brookline avenue',
        streetAddress2: null,
        city: 'Boston',
        postalCode: '12345',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: null,
      shortDescription: 'Tower Sq (DON"T EDIT)',
      longDescription: 'Tower Sq (DON"T EDIT)',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:4336589574',
      latitude: 67.778,
      longitude: -58.992,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/download_5b5673bb81e944d39cef5433fcfa4cb2.jpg',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/download_7e0cc8db55de4a4a8418f1fdb3c6c6ba.jpg',
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Tower Sq (DON"T EDIT)',
          shortDescription: 'Tower Sq (DON"T EDIT)',
          longDescription: 'Tower Sq (DON"T EDIT)',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/download_5b5673bb81e944d39cef5433fcfa4cb2.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/download_7e0cc8db55de4a4a8418f1fdb3c6c6ba.jpg',
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: '985487d9-f4bf-4f57-a964-436d2fca267a',
      title: 'WOV2 Test Store - DO NOT EDIT QA',
      address: {
        streetAddress1: '144, Brooklyn Avenue',
        streetAddress2: null,
        city: 'Brookline',
        postalCode: '2233',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: '5412200191',
      shortDescription:
        'WOV2 Test Store short description\nOpening hours: Anytime',
      longDescription:
        "WOV2 Test Store - Long Description.\nLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. I",
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:5699340785',
      latitude: 18.46554,
      longitude: -66.105736,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/shopping-kids-during-virus-outbreak-260nw-1677576121_b34edfd681f842d28728b3b047da73fc.jpg',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/cover_image.jpg.760x400_q85_crop_upscale_d304502fd0934c2a9b6939380641ba35.jpg',
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'WOV2 Test Store - DO NOT EDIT QA',
          shortDescription:
            'WOV2 Test Store short description\nOpening hours: Anytime',
          longDescription:
            "WOV2 Test Store - Long Description.\nLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. I",
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/shopping-kids-during-virus-outbreak-260nw-1677576121_b34edfd681f842d28728b3b047da73fc.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/cover_image.jpg.760x400_q85_crop_upscale_d304502fd0934c2a9b6939380641ba35.jpg',
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
    {
      storeId: '228cf720-bc0f-4445-9aaf-df6054b0a137',
      title: 'ZZ Store',
      address: {
        streetAddress1: '25 Drydock Avenue',
        streetAddress2: 'Innovation and Design Building',
        city: 'Boston',
        postalCode: '02210',
        region: 'Massachusetts',
        country: 'United States',
      },
      phoneNumber: '6027753196',
      shortDescription: 'ZZ Store',
      longDescription: 'ZZ Store',
      regionId: 'ee56ec86-b728-11e9-bf44-0aa9f0965c75',
      storeCode: 'STR:3222267881',
      latitude: 42.5076967,
      longitude: null,
      storeType: '11c0be0c-efa2-11e3-b939-02cbd19e9b93',
      beaconId: null,
      beaconName: null,
      smallImage: null,
      mediumImage: null,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'ZZ Store',
          shortDescription: 'ZZ Store',
          longDescription: 'ZZ Store',
          smallImage: null,
          mediumImage: null,
        },
      ],
      isMenuBrowsing: false,
      isCatering: false,
    },
  ],
};
